import {CHOOSE_GENERAL_HINT, CHOOSE_INCREASE_POWER_SOURCE_HINT, SHOW_HINT} from "./action";
import {AnyAction} from "redux";


/**
 * choose a hint to display based on game properties
 */
export function chooseGeneralHint() : AnyAction
{
    return {type: CHOOSE_GENERAL_HINT};
}


/**
 * choose a hint to display based on game properties
 */
export function chooseIncreasePowerSourceHint() : AnyAction
{
    return {type: CHOOSE_INCREASE_POWER_SOURCE_HINT};
}


/**
 * display a hint
 */
export function showHint(hint_id: string) : AnyAction
{
    return {type: SHOW_HINT, payload: {hint_id}};
}

/**
 * display the hints for the current year
 */
export function showHints() : AnyAction
{
    return {type: SHOW_HINT, payload: {}};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/hints.ts